import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import spacing from '../../../helpers/spacing';
import { CardGrid } from '../../CardGrid';

export const NoBackground = styled.div``;

export const Heading = styled.h2`
  ${fonts.headingMedium}
  text-align: left;
  margin-bottom: 0;
  margin-top: ${spacing(5)};
  font-weight: 700;
  color: ${colors.neutral01};
`;

export const Intro = styled.p`
  ${fonts.paragraph};
  margin-top: ${spacing(2)};
  margin-bottom: 0;
`;

//This empty style is used to add styling in the RSA Brochureware theme
export const StyledCardGrid = styled(CardGrid)``;
